import {z} from '@hono/zod-openapi';

import {readBy} from '../readBy/readBy';
import {conversationUser} from '../user/conversationUser';

const EventType = {
  PLAIN: 'PLAIN',
  WHATSAPP: 'WHATSAPP',
};

export const conversationEvent = z.object({
  id: z.string().uuid().openapi({
    description: 'ID of the event',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
  conversationId: z.string().uuid().openapi({
    description: 'ID of the conversation',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
  sender: conversationUser.openapi({
    description: 'User who sent the event',
  }),
  type: z.nativeEnum(EventType).openapi({
    description: 'Type of the event',
    example: 'PLAIN',
  }),
  content: z.string().openapi({
    description: 'Content of the event',
    example: 'Hello world!',
  }),
  deliveredAt: z.string().datetime().nullable().optional().openapi({
    description: 'Timestamp when the WhatsApp message was delivered (only for WHATSAPP type)',
    example: '2024-01-01T00:00:30.000Z',
  }),
  failedAt: z.string().datetime().nullable().optional().openapi({
    description: 'Timestamp when the WhatsApp message sending failed (only for WHATSAPP type)',
    example: '2024-01-01T00:00:45.000Z',
  }),
  readAt: z.string().datetime().nullable().optional().openapi({
    description: 'Timestamp when the WhatsApp message was read (only for WHATSAPP type)',
    example: '2024-01-01T00:01:00.000Z',
  }),
  mediaId: z.string().nullable().optional().openapi({
    description: 'Media ID for WhatsApp messages with media content (only for WHATSAPP type)',
    example: 'whatsapp-media-12345',
  }),
  whatsAppMessageId: z.string().min(1).nullable().optional().openapi({
    description: 'WhatsApp message ID (only for WHATSAPP type)',
    example:
      'wamid.ABGBIRNGNkVGNkUwMjkwMjQ0NjI5NjI1MDU2MjM0MDcwNjI5NjI0NDYyOTIwMjQ0NjI5NjI0NDYyNDQ2Mjk2MjQ0NjI5MjA0NjI5NjI0NDYyNDQ2Mjk2MjQ0NjI5',
  }),
  createdAt: z.string().datetime().openapi({
    description: 'Timestamp when the event was created',
    example: '2024-01-01T00:00:00.000Z',
  }),
  updatedAt: z.string().datetime().openapi({
    description: 'Timestamp when the event was updated',
    example: '2024-01-01T00:00:00.000Z',
  }),
  readBy: z.array(readBy).openapi({
    description: 'Array of users who have read the event',
  }),
});

export type ConversationEvent = z.infer<typeof conversationEvent>;
